export default __webpack_public_path__ + "static/media/vowels.baf06f51.svg";